package app.bloomey.web.core.data.models

import kotlinx.serialization.Serializable

@Serializable
data class LoginResponse(
    val user: Admin,
    val token: String,
)

@Serializable

data class Admin(
    val email: String,
    val id: String,
)
